import { Fragment, useEffect, useState } from 'react';
import { useStateValue } from '../../../../StateProvider';
import { actionTypes } from '../../../../reducer';
import './GridReportToggleTabs.css';

const GridReportToggleTabs = ({ reportName, compareToReportName }) => {
	const [ { mobileReportView }, dispatch ] = useStateValue();

	const handleMobileReportView = (view) => {
		dispatch({
			type             : actionTypes.SET_MOBILE_REPORT_VIEW,
			mobileReportView : view
		});
	};

	return (
		<Fragment>
			<div className="mobile-view-buttons d-lg-none d-flex">
				<button
					className={`report-toggle-button ${mobileReportView === 'base' ? 'active' : ''}`}
					onClick={() => handleMobileReportView('base')}
				>
					{reportName ? reportName : 'Base Report'}
				</button>
				<button
					className={`report-toggle-button ${mobileReportView === 'compare' ? 'active' : ''}`}
					onClick={() => handleMobileReportView('compare')}
				>
					{compareToReportName ? compareToReportName : 'Compare To Report'}
				</button>
			</div>
		</Fragment>
	);
};

export default GridReportToggleTabs;
